//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { RouteAnchor } from '@components/RouteAnchor';
import { BodyBoldText } from '@components/atoms/text/Text';
import bvLogo from '@images/bv-logo.svg';
import VibeGradLogo from '@images/bv-vibe-grad.svg';
import makeAngularReactController from '@react-bridge/angular-react-widget';
import { getIsVibeBrandingSunsetFeatureEnabled } from '@redux/selectors/getIsVibeBrandingSunsetFeatureEnabled';

export const NavLogo = () => {
  // TODO: PD-326016 - Remove feature flag after release
  const isVibeBrandingSunsetEnabled = useSelector(
    getIsVibeBrandingSunsetFeatureEnabled,
  );

  return (
    <VibeNavLink
      $isVibeBrandingSunsetEnabled={isVibeBrandingSunsetEnabled}
      state='index'
      stateParams={{ viaTopNav: true }}
    >
      {/* TODO: PD-326016 - Remove feature flag after release */}
      {isVibeBrandingSunsetEnabled ? (
        <>
          <BVLogo alt='Bazaarvoice' src={bvLogo} />
          <BVTitle>Social & Sampling</BVTitle>
        </>
      ) : (
        <VibeLogo alt='Vibe' src={VibeGradLogo} />
      )}
    </VibeNavLink>
  );
};

// TODO: PD-326016 - Remove $isVibeBrandingSunsetEnabled styling after feature flag release
const VibeNavLink = styled(RouteAnchor)<{
  $isVibeBrandingSunsetEnabled: boolean;
}>`
  ${({ $isVibeBrandingSunsetEnabled }) =>
    $isVibeBrandingSunsetEnabled
      ? `
    display: flex;
    align-items: center;
  `
      : ''}
  text-decoration: none;

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

// TODO: PD-326016 - Remove VibeLogo after feature flag release
const VibeLogo = styled.img`
  height: 28px;
  width: 137px;
`;

const BVTitle = styled(BodyBoldText)(
  ({ theme }) => `
  color: ${theme.colors.blue2};
`,
);

const BVLogo = styled.img(
  ({ theme }) => `
  height: 28px;
  width: 28px;
  margin-left: ${theme.spacings[5]};
  margin-right: ${theme.spacings[2]};
`,
);

angular.module('curalate').component('navLogo', {
  controller: makeAngularReactController(<NavLogo />),
});
